'use client'

import { useEffect, useRef } from 'react'

export const useDebouncedEffect = (effect, deps, delayMs = 300, { skipFirst = false } = {}) => {
  const isFirst = useRef(true)

  useEffect(() => {
    if (skipFirst && isFirst.current) {
      isFirst.current = false
      return
    }
    isFirst.current = false

    const timeoutId = setTimeout(() => {
      effect?.()
    }, delayMs)

    return () => clearTimeout(timeoutId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)
}
